module.exports = __webpack_public_path__ + "static/img/img9.467f778.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/img9.png
// module id = mCFq
// module chunks = 1